import { AxiosError } from 'axios'
import { useCallback, useMemo } from 'react'
import { useMutation, UseMutationOptions } from 'react-query'
import { OAuthLoginRequest } from '../interfaces/OAuthLoginRequest'
import { OAuthErrorResponse } from '../interfaces/OAuthErrorResponse'
import { OAuthInteractionResponse } from '../interfaces/OAuthInteractionResponse'
import { useIamManagerOAuth } from '../useIamManagerOAuth'

type Response = OAuthInteractionResponse
export type UseOAuthLoginOptions = UseMutationOptions<
  Response,
  AxiosError<OAuthErrorResponse>,
  OAuthLoginRequest
>

export const useOAuthLogin = (options?: UseOAuthLoginOptions) => {
  const { endpoint, login } = useIamManagerOAuth()
  const mutationKey = useMemo(() => [endpoint, 'login'], [endpoint])
  const mutationFn = useCallback(
    async (input: OAuthLoginRequest) => (await login(input)).data,
    [login]
  )
  return useMutation<Response, AxiosError<OAuthErrorResponse>, OAuthLoginRequest>({
    ...options,
    mutationKey,
    mutationFn,
    retry: false
  })
}
